'use client'

import { useNotFoundTranslations } from '@/contexts/notFoundTranslationsContext'
import { detectClientLocale } from '@/utils/client-locale-detection'
import NotFound from './NotFound'

export default function ContextBasedNotFound() {
	const { getTranslation } = useNotFoundTranslations()

	// Get the current pathname to extract locale
	const pathname = typeof window !== 'undefined' ? window.location.pathname : ''

	// Use the client-side locale detection utility for translations (language part)
	const { shortLocale, fullLocale } = detectClientLocale(pathname)

	// Get translation from context using language part
	const translation = getTranslation(shortLocale || 'en')

	return <NotFound fragment={translation} locale={fullLocale} />
}
